import { AllSubscriptionData } from "@/features/player/api/types";
import { RAG_API_URL } from "@/shared/config/player";
import { RagResponse } from "@/features/rag/model/types";

export const ragAsk = async (requestBody: {
    question: string;
    limit: number;
    min_relevance: number;
    debug: boolean;
}): Promise<RagResponse> => {
    const response = await fetch(`${RAG_API_URL}/ask`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
};
